import { FC } from "preact/compat";
import { SingleWidgetProps } from "../interfaces";
import Breakdown from "./Breakdown";

const Project: FC<SingleWidgetProps> = ({ id, className }) => (
    <Breakdown id={id} by="project" className={className} />
);

export default Project;
